<template>
    <div class="dt-result-member-names"
         :class="{'inactive': !membership.isActive()}">
        <div>
            <h5>{{ l('MEMBERSHIP') }} {{ membership.ref }}</h5>
            <ul>
                <li v-for="member in membersWithNames"
                    :key="member.ID">
                    <i class="fa-solid fa-fw fa-user"></i>
                    <span>
                        <ContactName :contact="member.contact" />
                        <small v-if="member.contact.ref">({{ member.contact.ref }})</small>
                    </span>
                </li>
            </ul>
        </div>

        <button v-if="!membership.isDead()"
                class="btn btn-default">
            <i class="fa-solid fa-arrow-right"></i>
        </button>
    </div>
</template>

<script>
import ContactName from '@/epos/vue/components/Customers/ContactName';

export default {
    components: {
        ContactName,
    },

    props: {
        membership: {
            type: Object,
            required: true,
        },
    },

    computed: {
        membersWithNames() {
            return this.membership.members.filter((member) => {
                return member.hasContact() && member.contact.getFullName();
            });
        },
    },
};
</script>
